import { Cookies } from 'react-cookie'

export const authTokenCookieName = 'glasshouse-token'
export const environmentCookieName = 'token-env'

const cookies = new Cookies()

const cookieOptions: any = { path: '/' }

if (process.env.NODE_ENV === 'production') {
  cookieOptions.secure = true
  cookieOptions.sameSite = 'Lax'
  cookieOptions.domain = '.imperium.markets'
}

const setCookie = (key: string, value: string) => cookies.set(key, value, cookieOptions)

const getCookie = (key: string) => cookies.get(key)

const removeCookie = (key: string) => cookies.remove(key, cookieOptions)

export const setAuthCookie = (token: string, environment: string) => {
  setCookie(authTokenCookieName, token)
  setCookie(environmentCookieName, environment)
}

export const getAuthCookie = () => ({
  token: getCookie(authTokenCookieName),
  environment: getCookie(environmentCookieName),
})

export const removeAuthCookie = () => {
  removeCookie(authTokenCookieName)
  removeCookie(environmentCookieName)
}

export { cookieOptions }
